import * as React from 'react';
import { Link } from 'react-static';
import * as classnames from 'classnames/bind';
import SVGInline from 'react-svg-inline';

import styles from './Footer.scss';
import { FooterLocale, Link as LocaleLink, Column } from './footer.locale';
import LinkButton from '../Button/LinkButton';
import facebookIcon from '../Icon/facebook.svg';
import twitterIcon from '../Icon/twitter.svg';
import linkedinIcon from '../Icon/linkedin.svg';

const cx = classnames.bind(styles);

interface FooterProps {
  locale: FooterLocale;
  onLinkClick: (href: string) => void;
}

const Footer: React.SFC<FooterProps> = ({ locale, onLinkClick }) => {
  const renderLink = (link: LocaleLink, className: string) => (
    <Link
      key={link.href}
      to={link.href}
      className={`${styles.link} ${link.visibleOnMobile ? 'd-block' : ''} ${className}`}
      onClick={() => onLinkClick(link.href)}
    >
      {link.text}
    </Link>
  );

  const renderLinks = (column: Column) => {
    const links: JSX.Element[] = [];

    column.links.forEach(link => {
      if ('availabilityHere' in link) {
        links.push(
          <div key={column.availabilityInfo} className={`${styles.availability} d-none d-md-block`}>
            {column.availabilityInfo}
          </div>,
        );
      } else {
        links.push(renderLink(link, ''));

        if (link.links) {
          link.links.forEach(subLink => links.push(renderLink(subLink, 'ml-4')));
        }
      }
    });

    return links;
  };

  const renderLinkColumns = () =>
    Object.entries(locale.linkColumns).map(([key, column]) => (
      <div
        key={key}
        className={cx({
          [key]: true,
        })}
      >
        <div className="d-flex flex-column">
          <div className={styles.title}>
            {column.title}
            {column.availabilityInfo && (
              <span className={`${styles.availability} d-md-none`}>{column.availabilityInfo}</span>
            )}
          </div>
          {renderLinks(column)}
        </div>
        <div className={`${styles.horizontalLine} d-sm-none`} />
      </div>
    ));

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className="d-flex flex-column flex-lg-row">
          <div className="d-flex flex-column flex-sm-row justify-content-between w-100">
            {renderLinkColumns()}
            <div />
          </div>
          <div className={`${styles.horizontalLine} d-none d-sm-block d-lg-none`} />
          <div className={styles.verticalLine} />
          <div className={styles.additionalSection}>
            <div className={styles.socialLinks}>
              <div className="d-flex align-items-center justify-content-start justify-content-sm-center">
                <Link to="https://www.facebook.com/Peering.cz" target="_blank" rel="noopener">
                  <SVGInline svg={facebookIcon} className="d-flex" />
                </Link>
                <Link
                  to="https://twitter.com/peering_cz"
                  target="_blank"
                  rel="noopener"
                  className="mx-5"
                >
                  <SVGInline svg={twitterIcon} className="d-flex" />
                </Link>
                <Link
                  to="https://www.linkedin.com/company/peering-cz"
                  target="_blank"
                  rel="noopener"
                >
                  <SVGInline svg={linkedinIcon} className="d-flex" />
                </Link>
              </div>
              <div className={`${styles.horizontalLine} d-sm-none`} />
            </div>
            <div className="mb-4 mb-sm-5">
              <LinkButton to={locale.button.href} target="_blank" rel="noopener">
                {locale.button.text}
              </LinkButton>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// /www/client/src/components/Footer/Footer.tsx